import styled from 'styled-components';
import Modal from '../Modal';
import Icon from '../Icon';
import { StyledButton as Button } from '../Button';

export const FilterHeader = styled.div`
  background: #fff8f8;
  color: rgba(74, 74, 74, 0.55);
  font-size: 12px;
  letter-spacing: 0.1px;
  display: flex;
  justify-content: space-between;
  align-items: center;
  padding: 16px 23px;
  border-top-left-radius: 4px;
  border-top-right-radius: 4px;
`;

export const ClearButton = styled(Button).attrs({
  appearance: 'link',
})`
  color: #0078D4;
  letter-spacing: -0.1px;
  font-weight: normal;
  font-size: 14px;
`;

export const StyledModal = styled(Modal)`
  &__content {
    width: 80%;
    border-radius: 4px;
    max-height: 90vh;
    overflow-y: auto;
  }
`;

export const FilterList = styled.ul`
  list-style-type: none;
  padding: 0 20px;
  margin: 0;
`;

export const CheckedIcon = styled(Icon).attrs({
  className: 'fa fa-check',
})`
  color: #7979FF;
  position: absolute;
  right: 20px;
  top: 50%;
  transform: translateY(-50%);
`;

export const FilterItem = styled.li`
  padding: 15px 20px;
  letter-spacing: 0.2px;
  color: #4a4a4a;
  cursor: pointer;
  position: relative;

  & + & {
    border-top: 1px solid rgba(151, 151, 151, 0.15);
  }
`;
